module.exports = __webpack_public_path__ + "static/media/butterfly1.8af5188a.svg";